import React from 'react'
import { Card } from 'antd'
import * as steps from '../form-steps'
import { CustomTitle } from 'src/components'
import { useTranslation } from 'next-i18next'
import { useAppSelector } from 'src/app/hooks'
import { completeInfoFormStep } from 'src/features'
import styles from './CompleteRegisterCard.module.scss'

const CompleteRegisterCard: React.FC = () => {
  const { t } = useTranslation()
  const currenctStep = useAppSelector(completeInfoFormStep)

  const cardProps = {
    className: styles['card'],
    title: <CustomTitle label={t('Auth.CompleteInfo.CardTitle')} />,
    extra: <CustomTitle label={`${currenctStep}/3`} className='float-right' type={null} />,
  }

  const formSteps = [steps.ConfirmSellerRolStep, steps.CompleteRegisterInfoForm, steps.CompleteRegisterFormFiles]
  const CurrentStep = formSteps[currenctStep - 1] || steps.ConfirmSellerRolStep

  return <Card {...cardProps}><CurrentStep /></Card>
}

export default CompleteRegisterCard
